import { HighlightOff, Save } from "@mui/icons-material";
import {
  Button,
  FormControlLabel,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { SAVE_PERSON_CONSENT } from "../../redux/reducers/personReducer";
import { ModalRoot } from "../modal/ModalRoot";
import { NavLink } from "react-router";

export function ManagePerson() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const carePrincipalId = useSelector(
    (store: any) => store.session.selectedCarePrincipal.id
  );
  const fetchedSettings = useSelector((store: any) => store.person.cardConsent);
  const currentUser = useSelector((store: any) => store.session.currentUser);
  const searchForm = useSelector((store: any) => store.card.params);
  const [currentSettings, setCurrentSettings] = useState({
    sendPostToCarePrincipal: false,
    exportRestriction: false,
    recurringCard: false,
  });

  const [change, setChange] = useState({
    sendPostToCarePrincipal: null,
    exportRestriction: null,
    recurringCard: null,
  });

  useEffect(() => {
    setCurrentSettings({
      ...currentSettings,
      sendPostToCarePrincipal: fetchedSettings.sendPostToCarePrincipal
        ? true
        : false,
      exportRestriction: fetchedSettings.exportRestriction ? true : false,
      recurringCard: fetchedSettings.recurringCard ? true : false,
    });
  }, [fetchedSettings]); //eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentSettings({
      ...currentSettings,
      [event.target.name]: event.target.checked,
    });
    setChange({
      ...change,
      [event.target.name]: event.target.checked,
    });
  };

  const settingsChanged = () => {
    return (
      currentSettings.sendPostToCarePrincipal ===
        (fetchedSettings.sendPostToCarePrincipal ? true : false) &&
      currentSettings.exportRestriction ===
        (fetchedSettings.exportRestriction ? true : false) &&
      currentSettings.recurringCard ===
        (fetchedSettings.recurringCard ? true : false)
    );
  };

  const saveSettings = () => {
    const params = {
      carePrincipalId: carePrincipalId,
      personId: searchForm.personId,
      cardTypeId: searchForm.cardTypeId,
      consent: {
        sendPostToCarePrincipal: change.sendPostToCarePrincipal,
        exportRestriction: change.exportRestriction,
        recurringCard: change.recurringCard,
        optIn: null,
        optOut: null,
      },
    };
    dispatch({ type: SAVE_PERSON_CONSENT, params });
  };

  const registerOptOut = () => {
    const params = {
      carePrincipalId: carePrincipalId,
      personId: searchForm.personId,
      cardTypeId: searchForm.cardTypeId,
      consent: {
        sendPostToCarePrincipal: currentSettings.sendPostToCarePrincipal,
        exportRestriction: currentSettings.exportRestriction,
        recurringCard: currentSettings.recurringCard,
        optIn: false,
        optOut: true,
      },
    };
    dispatch({ type: "REGISTER_OPT_OUT", params });
  };

  return (
    <Box>
      <h3>{t("searchCard.managePerson.title")}</h3>
      <Stack spacing={2} maxWidth="20rem">
        <Box>
          <Typography>
            {t("searchCard.managePerson.sendPostToCarePrincipal.description")}
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="body2">
              {t("searchCard.managePerson.sendPostToCarePrincipal.nationalPU")}
            </Typography>
            <FormControlLabel
              control={
                <Switch
                  checked={currentSettings.sendPostToCarePrincipal}
                  onChange={handleChange}
                  name="sendPostToCarePrincipal"
                />
              }
              label={
                <Typography variant="body2">
                  {currentUser !== undefined
                    ? carePrincipalId
                    : t("carePrincipal")}
                </Typography>
              }
            />
          </Stack>
        </Box>
        <FormControlLabel
          control={
            <Switch
              checked={currentSettings.exportRestriction}
              onChange={handleChange}
              name="exportRestriction"
            />
          }
          label={t<string>("searchCard.managePerson.exportRestriction")}
        />
        <FormControlLabel
          control={
            <Switch
              checked={currentSettings.recurringCard}
              onChange={handleChange}
              name="recurringCard"
            />
          }
          label={t<string>("searchCard.managePerson.recurringCard")}
        />
        <Button
          disabled={settingsChanged()}
          onClick={saveSettings}
          variant="contained"
          startIcon={<Save />}
        >
          {t("saveChanges")}
        </Button>
        <Button
          variant="outlined"
          onClick={registerOptOut}
          startIcon={<HighlightOff />}
          color="error"
          title={t("tooltip.optOut")}
        >
          {t("searchCard.managePerson.optOut")}
        </Button>
      </Stack>
      <Stack>
        <Button
          sx={{ marginTop: "1.6rem", maxWidth: "6rem" }}
          component={NavLink}
          to={"/search-card"}
          variant="contained"
        >
          {t("back")}
        </Button>
      </Stack>
      <ModalRoot />
    </Box>
  );
}
